import Vue from 'vue'
import VueI18n from 'vue-i18n'

import th from './lang/th'
import en from './lang/en'
import la from './lang/la'
import mm from './lang/mm'
import kh from './lang/kh'

Vue.use(VueI18n)

const supportedLocales = ['th', 'en', 'la', 'mm', 'kh'];

const i18n = new VueI18n({
    locale: 'en',        // ค่าเริ่มต้น (เดี๋ยวเปลี่ยนทีหลัง)
    fallbackLocale: 'en',
    messages: {
        en,
        th,
        la,
        mm,
        kh
    }
});

// helper function ไว้ set locale อย่างปลอดภัย
export function setLocale(locale) {
    i18n.locale = supportedLocales.includes(locale)
        ? locale
        : 'en';
}

export default i18n;